import { mountSingleRace } from './utils/mount-single-race.js';
import { STATE_URL } from './constants.js';

mountSingleRace('CA-H83596-2026-06-02', STATE_URL).catch(console.error);
